import type { ThemeToken } from '../../../design-tokens';

// Single source for the colour data shown on every Data Visualization page (DI-032).

type DatavizKey = Extract<ThemeToken, `dataviz${string}`>;

interface UseCasePalette {
  title: string;
  subtitle: string;
  keys: readonly DatavizKey[];
}

// The palette blocks of the Use case tab, as the Figma frames draw them (D1): title, subtitle and the
// dataviz key of each swatch in drawn order. The frames draw Sequential 7-1 dark to light as 7 swatches.
export const useCasePalettes = {
  qualitative: {
    title: 'Qualitative Palette - Distinct Categories',
    subtitle: 'To differentiate discrete categories.',
    keys: [
      'datavizQualitative121',
      'datavizQualitative122',
      'datavizQualitative123',
      'datavizQualitative124',
      'datavizQualitative125',
      'datavizQualitative126',
      'datavizQualitative127',
      'datavizQualitative128',
      'datavizQualitative129',
      'datavizQualitative1210',
      'datavizQualitative1211',
      'datavizQualitative1212',
    ],
  },
  sequential: {
    title: 'Sequential Palette - Continuous Values',
    subtitle: 'To showcase categorical values.',
    keys: [
      'datavizSequential717',
      'datavizSequential716',
      'datavizSequential715',
      'datavizSequential714',
      'datavizSequential713',
      'datavizSequential712',
      'datavizSequential711',
    ],
  },
  diverging: {
    title: 'Diverging Palette - Meaningful Central Value',
    subtitle: 'To highlight differences from a central reference point.',
    keys: [
      'datavizDiverging911',
      'datavizDiverging912',
      'datavizDiverging913',
      'datavizDiverging914',
      'datavizDiverging915',
      'datavizDiverging916',
      'datavizDiverging917',
      'datavizDiverging918',
      'datavizDiverging919',
    ],
  },
} as const satisfies Record<string, UseCasePalette>;

export type UseCasePaletteId = keyof typeof useCasePalettes;

// The Usability tab values below are the literals the 38 UsabilityTab copies carried; do not change them
// here. None maps to a dataviz* theme key (DI-032): no Figma frame draws the Usability tab, so each stays
// literal and carries a tokens-allow marker naming the reason.

export const dataColorVision = [
  { id: 1, title: 'Normal', color: '#2d6e8d' }, // tokens-allow: DI-032 no frame draws the Usability tab
  { id: 2, title: 'Protanopia', color: '#526dbc' }, // tokens-allow: DI-032 colour-vision simulation, not a palette entry
  { id: 3, title: 'Deuteranopia', color: '#4770b7' }, // tokens-allow: DI-032 colour-vision simulation, not a palette entry
  { id: 4, title: 'Tritanopia', color: '#517881' }, // tokens-allow: DI-032 colour-vision simulation, not a palette entry
];

export const readabilityTextColor = '#5C636E'; // tokens-allow: DI-032 no frame draws the Usability tab
export const readabilityBackgroundColor = '#FFFFFF'; // tokens-allow: DI-032 no frame draws the Usability tab
export const contrastElementColor = '#5C6BC0'; // tokens-allow: DI-032 no frame draws the Usability tab
export const contrastBackgroundColor = '#FFFFFF'; // tokens-allow: DI-032 no frame draws the Usability tab
